import { render, staticRenderFns } from "./haka-yliopisto.vue?vue&type=template&id=79f8a369&scoped=true&"
import script from "./haka-yliopisto.vue?vue&type=script&lang=ts&"
export * from "./haka-yliopisto.vue?vue&type=script&lang=ts&"
import style0 from "./haka-yliopisto.vue?vue&type=style&index=0&id=79f8a369&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79f8a369",
  null
  
)

export default component.exports